import { render, staticRenderFns } from "./ChangeAccountPasswordModal.vue?vue&type=template&id=24145e76"
import script from "./ChangeAccountPasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangeAccountPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccountPasswordModal.vue?vue&type=style&index=0&id=24145e76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports